export default "__VITE_PUBLIC_ASSET__3eea677f__"